import {Switch, Match, Suspense} from "solid-js";
import OrderCart from "./steps/OrderCart";
import OrderCustomer from "./steps/OrderCustomer";
import OrderPayment from "./steps/OrderPayment";
import OrderShipping from "./steps/OrderShipping";
import OrderConfirm from "./steps/OrderConfirm";
import OrderCancel from "./steps/OrderCancel";

export default ({step}) => {

    return (
        <Suspense fallback={<div class="container">Chargement de votre commande...</div>}>
            <div class="container">
                <Switch>
                    <Match when={step() === "cart"}><OrderCart /></Match>
                    <Match when={step() === "customer"}><OrderCustomer /></Match>
                    <Match when={step() === "shipping"}><OrderShipping /></Match>
                    <Match when={step() === "payment"}><OrderPayment /></Match>
                    <Match when={step() === "confirm"}><OrderConfirm /></Match>
                    {/*
                      Annulation depuis le lien e-mail, sans session : le code
                      de commande fait office de justificatif. L'ancienne page
                      annulait TOUTE la commande d'un clic — c'était ça le bug,
                      pas l'accès par code. Elle annule désormais réservation
                      par réservation, et le backend vérifie que la ligne
                      appartient bien à la commande que le code désigne.
                    */}
                    <Match when={step() === "cancel"}><OrderCancel /></Match>
                </Switch>
            </div>
        </Suspense>
    );
};
